import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

// Modal "Datos del cupón": trabajos a realizar, reporte del cliente y accesorios no
// originales. Componente controlado y aparte (más adelante la garantía reutiliza esta misma
// ventana) — no decide a dónde van los datos, solo los junta y valida; el padre decide si los
// guarda localmente (ingreso) o los manda al backend (edición de un trabajo activo).
export const DatosCuponDialog = ({ open, onOpenChange, valorInicial, vehiculo, cuponIncompleto,
  onGuardar, guardando = false }) => {
  const [trabajosRealizar, setTrabajosRealizar] = useState("");
  const [reportaProblema, setReportaProblema] = useState(null);
  const [problemaDetalle, setProblemaDetalle] = useState("");
  const [accesoriosNoOriginales, setAccesoriosNoOriginales] = useState(null);
  const [accesoriosDetalle, setAccesoriosDetalle] = useState("");

  useEffect(() => {
    if (!open) return;
    if (valorInicial) {
      setTrabajosRealizar(valorInicial.trabajos_realizar || "");
      setReportaProblema(valorInicial.reporta_problema ?? null);
      setProblemaDetalle(valorInicial.problema_detalle || "");
      setAccesoriosNoOriginales(valorInicial.accesorios_no_originales ?? null);
      setAccesoriosDetalle(valorInicial.accesorios_detalle || "");
      return;
    }
    setTrabajosRealizar(cuponIncompleto ? "Se realizan trabajos pendientes del cupón" : "");
    setReportaProblema(null);
    setProblemaDetalle("");
    // Accesorios: lo único que se precarga desde el vehículo (editable); las otras dos
    // preguntas siempre arrancan vacías.
    if (vehiculo?.accesorios_no_originales) {
      setAccesoriosNoOriginales(true);
      setAccesoriosDetalle(vehiculo.accesorios_detalle || "");
    } else {
      setAccesoriosNoOriginales(null);
      setAccesoriosDetalle("");
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const valido = trabajosRealizar.trim() && reportaProblema !== null &&
    (!reportaProblema || problemaDetalle.trim()) &&
    accesoriosNoOriginales !== null && (!accesoriosNoOriginales || accesoriosDetalle.trim());

  const guardar = () => {
    if (!valido) return;
    onGuardar({
      trabajos_realizar: trabajosRealizar.trim(),
      reporta_problema: !!reportaProblema,
      problema_detalle: reportaProblema ? problemaDetalle.trim() : "",
      accesorios_no_originales: !!accesoriosNoOriginales,
      accesorios_detalle: accesoriosNoOriginales ? accesoriosDetalle.trim() : "",
    });
  };

  const BotonSiNo = ({ valor, onChange, testId }) => (
    <div className="flex gap-2">
      <Button type="button" size="sm" data-testid={`${testId}-si`}
        variant={valor === true ? "default" : "outline"}
        className={valor === true ? "bg-indigo-600 hover:bg-indigo-700 text-white" : ""}
        onClick={() => onChange(true)}>
        Sí
      </Button>
      <Button type="button" size="sm" data-testid={`${testId}-no`}
        variant={valor === false ? "default" : "outline"}
        className={valor === false ? "bg-indigo-600 hover:bg-indigo-700 text-white" : ""}
        onClick={() => onChange(false)}>
        No
      </Button>
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="datos-cupon-dialog" className="bg-white max-w-lg">
        <DialogHeader>
          <DialogTitle>Datos del cupón</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <label className="text-sm font-medium text-slate-700">Trabajos a realizar</label>
            <Textarea data-testid="datos-cupon-trabajos-input" rows={3} value={trabajosRealizar}
              onChange={(e) => setTrabajosRealizar(e.target.value)} placeholder="Anote el trabajo a realizar" />
          </div>

          <div className="space-y-1.5">
            <label className="text-sm font-medium text-slate-700">¿El cliente reporta algún problema?</label>
            <BotonSiNo valor={reportaProblema} testId="datos-cupon-reporta"
              onChange={(v) => { setReportaProblema(v); if (!v) setProblemaDetalle(""); }} />
            {reportaProblema === true && (
              <Textarea data-testid="datos-cupon-problema-detalle-input" rows={2} value={problemaDetalle}
                onChange={(e) => setProblemaDetalle(e.target.value)} placeholder="Detalle del problema reportado"
                className="mt-1.5" />
            )}
          </div>

          <div className="space-y-1.5">
            <label className="text-sm font-medium text-slate-700">¿La moto tiene accesorios no originales?</label>
            <BotonSiNo valor={accesoriosNoOriginales} testId="datos-cupon-accesorios"
              onChange={(v) => { setAccesoriosNoOriginales(v); if (!v) setAccesoriosDetalle(""); }} />
            {accesoriosNoOriginales === true && (
              <Textarea data-testid="datos-cupon-accesorios-detalle-input" rows={2} value={accesoriosDetalle}
                onChange={(e) => setAccesoriosDetalle(e.target.value)} placeholder="Detalle de los accesorios"
                className="mt-1.5" />
            )}
          </div>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" data-testid="datos-cupon-cancelar-btn" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button data-testid="datos-cupon-guardar-btn" onClick={guardar} disabled={!valido || guardando}
            className="bg-indigo-600 hover:bg-indigo-700 text-white">
            {guardando ? "Guardando..." : "Guardar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
